import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { Http } from '../../../../support';
import Loading from '../../../../facturotopia/loading/Loading';
import ResponseError from '../../../../shared/responses/ResponseError';
import ResponseResult from '../../../../shared/responses/ResponseResult';

class TimbradoTicketSearch extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {
        tickets: null,
      },
      busy: false,
      error: null,
      result: null,
    };
  }

  componentDidMount() {
    this.fetching();
  }

  fetching = async () => {
    const { id } = this.props.match.params;

    this.setState({
      busy: true,
    });

    const params = { id };

    try {
      const response = await Http.get('api/autofacturacion/tickets/search', { params });

      if (response.data?.link) {
        this.setState({
          busy: false,
          result: response,
        });
      } else {
        const info = response.data;

        const tickets = {
          ...this.state.data.tickets,
          [info.id]: info,
        };

        this.setState({
          busy: false,
          data: {
            tickets,
            ticketsCount: Object.keys(tickets).length,
          },
        });

        this.next();
      }
    } catch (error) {
      this.setState({
        busy: false,
        error: error.data || error,
      });
    }
  };

  next = () => {
    const tickets = Object.values(this.state.data.tickets);
    let conceptos = [];
    let data = { ...tickets[0].input };

    for (const item of tickets) {
      const { input } = item;

      conceptos = conceptos.concat(input.Conceptos.Concepto);
    }

    data.Conceptos = {
      Concepto: conceptos,
    };

    data = {
      tickets: Object.keys(this.state.data.tickets),
      ...tickets[0].input,
    };

    this.props.onChange({ data });
  };

  handleResetError = () => {
    this.setState({
      error: undefined,
    });
  };

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleResetError}
        />
      </div>
    );
  };

  renderResult = () => {
    const { result: _result, downloaded } = this.state;

    let result = {
      ..._result,
      message: _result.message + ' Si quieres descargar tu factura haz click en "Descargar"',
    };

    if (downloaded) {
      return (
        <div className="result-container">
          <ResponseResult
            title="Factura emitida."
            result={result}
            btnText="Continuar"
            onAction={this.handleOnDone}
          />
        </div>
      );
    }

    return (
      <div className="result-container">
        <ResponseResult
          title="Factura emitida."
          result={result}
          btnText="Descargar mi factura"
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  handleOnDone = () => {
    this.setState({
      data: {},
      error: undefined,
      result: undefined,
      downloaded: false,
    });
  };

  handleOnAction = () => {
    const { result } = this.state;

    window.location = result.data.link;

    this.setState({
      downloaded: true,
    });

    this.props.history.replace('/modulos/autofacturacion/tickets');
  };

  render() {
    const { busy, error, result } = this.state;

    if (busy) {
      return <Loading />;
    }

    return (
      <>
        {!!error && this.renderError()}
        {!!result && this.renderResult()}
      </>
    );
  }
}

export default withRouter(TimbradoTicketSearch);
